import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

import instance from './classes/Store/Instance'
import identity from './classes/Store/Identity'
import contact from './classes/Store/Contact'
import dataView from './classes/Store/DataView'
import valuation from './classes/Store/Valuation'
import lead from './classes/Store/Lead'
import user from './classes/Store/User'
import notifications from './classes/Store/Notifications'
import inbox from './classes/Store/Inbox'

const store = new Vuex.Store({
    state: {
        // Base state
    },
    modules: {
        instance,
        identity,
        contact,
        dataView,
        valuation,
        lead,
        user,
        notifications,
        inbox
    },
});

export default store;